
import { printf, toText } from "./fable_modules/fable-library-js.5.0.0/String.js";
import { Remoting_buildProxy_64DC51C } from "./fable_modules/Fable.Remoting.Client.8.0.0/./Remoting.fs.js";
import { RemotingModule_createApi, RemotingModule_withRouteBuilder } from "./fable_modules/Fable.Remoting.Client.8.0.0/Remoting.fs.js";
import { INetHackApi_$reflection } from "../../Server/Shared.fs.js";
import { singleton } from "./fable_modules/fable-library-js.5.0.0/AsyncBuilder.js";
import { catchAsync } from "./fable_modules/fable-library-js.5.0.0/Async.js";
import { some } from "./fable_modules/fable-library-js.5.0.0/Option.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.5.0.0/Result.js";

/**
 * Prefix routes with /NetHackWeb.
 */
export function routeBuilder(typeName, methodName) {
    return toText(printf("/NetHack/%s/%s"))(typeName)(methodName);
}

export const api = Remoting_buildProxy_64DC51C(RemotingModule_withRouteBuilder(routeBuilder, RemotingModule_createApi()), INetHackApi_$reflection());

/**
 * Gets the current number of game states.
 */
export function getStateCount() {
    return singleton.Delay(() => singleton.Bind(catchAsync(api.GetStateCount()), (_arg) => {
        if (_arg.tag === 1) {
            const exn = _arg.fields[0];
            console.log(some(exn.message));
            return singleton.Return(new FSharpResult$2(1, [exn.message]));
        }
        else {
            return singleton.Return(new FSharpResult$2(0, [_arg.fields[0]]));
        }
    }));
}

/**
 * Gets the session state at the given 0-based index.
 */
export function getSessionState(stateIdx) {
    return singleton.Delay(() => singleton.Bind(catchAsync(api.GetSessionState(stateIdx)), (_arg) => {
        if (_arg.tag === 1) {
            console.log(some(_arg.fields[0].message));
            return singleton.Return(new FSharpResult$2(1, [_arg.fields[0].message]));
        }
        else {
            const copyOfStruct = _arg.fields[0];
            if (copyOfStruct.tag === 1) {
                console.log(some(copyOfStruct.fields[0]));
                return singleton.Return(new FSharpResult$2(1, [copyOfStruct.fields[0]]));
            }
            else {
                return singleton.Return(new FSharpResult$2(0, [copyOfStruct.fields[0]]));
            }
        }
    }));
}

